"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentManagementApiEndpoints = exports.ContentManagementApiEndpoints = void 0;
var ContentManagementApiEndpoints = /** @class */ (function () {
    function ContentManagementApiEndpoints() {
    }
    ContentManagementApiEndpoints.prototype.changeWorkflowStepOfLanguageVariant = function (itemIdentifier, languageIdentifier, workflowIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/workflow/" + workflowIdentifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.publishLaguageVariant = function (itemIdentifier, languageIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/publish";
    };
    ContentManagementApiEndpoints.prototype.createNewVersionOfALanguageVariant = function (itemIdentifier, languageIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/new-version";
    };
    ContentManagementApiEndpoints.prototype.unpublishLanguageVariant = function (itemIdentifier, languageIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/unpublish-and-archive";
    };
    ContentManagementApiEndpoints.prototype.cancelScheduledPublishingOfLanguageVariant = function (itemIdentifier, languageIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/cancel-scheduled-publish";
    };
    ContentManagementApiEndpoints.prototype.cancelScheduledUnpublishingOfLanguageVariant = function (itemIdentifier, languageIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + languageIdentifier.getParamValue() + "/cancel-scheduled-unpublish";
    };
    ContentManagementApiEndpoints.prototype.listWorkflowSteps = function () {
        return "workflow";
    };
    ContentManagementApiEndpoints.prototype.listContentTypeSnippets = function () {
        return "snippets";
    };
    ContentManagementApiEndpoints.prototype.viewContentTypeSnippet = function (identifier) {
        return "snippets/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addContentTypeSnippet = function () {
        return "snippets";
    };
    ContentManagementApiEndpoints.prototype.deleteContentTypeSnippet = function (identifier) {
        return "snippets/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.modifyContentTypeSnippet = function (identifier) {
        return "snippets/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.validateProjectContent = function () {
        return "validate";
    };
    ContentManagementApiEndpoints.prototype.projectInformation = function () {
        return "";
    };
    ContentManagementApiEndpoints.prototype.listContentTypes = function () {
        return "types";
    };
    ContentManagementApiEndpoints.prototype.addContentType = function () {
        return "types";
    };
    ContentManagementApiEndpoints.prototype.deleteContentType = function (identifier) {
        return "types/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.viewContentType = function (identifier) {
        return "types/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.modifyContentType = function (identifier) {
        return "types/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addTaxonomy = function () {
        return "taxonomies";
    };
    ContentManagementApiEndpoints.prototype.modifyTaxonomy = function (identifier) {
        return "taxonomies/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.deleteTaxonomy = function (identifier) {
        return "taxonomies/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.listTaxonomies = function () {
        return "taxonomies";
    };
    ContentManagementApiEndpoints.prototype.getTaxonomy = function (identifier) {
        return "taxonomies/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addAsset = function () {
        return "assets";
    };
    ContentManagementApiEndpoints.prototype.deleteAsset = function (identifier) {
        return "assets/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.upsertAsset = function (assetIdentifier) {
        return "assets/" + assetIdentifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.uploadBinaryFile = function (filename) {
        return "files/" + filename;
    };
    ContentManagementApiEndpoints.prototype.listAssets = function () {
        return 'assets';
    };
    ContentManagementApiEndpoints.prototype.viewAsset = function (identifier) {
        return "assets/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.items = function () {
        return 'items';
    };
    ContentManagementApiEndpoints.prototype.viewContentItem = function (identifier) {
        return "items/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addContentItem = function () {
        return "items";
    };
    ContentManagementApiEndpoints.prototype.updateContentItem = function (identifier) {
        return "items/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.upsertContentItem = function (identifier) {
        return "items/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.deleteContentItem = function (identifier) {
        return "items/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.listLanguageVariantsOfItem = function (identifier) {
        return "items/" + identifier.getParamValue() + "/variants";
    };
    ContentManagementApiEndpoints.prototype.listLanguageVariantsOfContentType = function (identifier) {
        return "types/" + identifier.getParamValue() + "/variants";
    };
    ContentManagementApiEndpoints.prototype.listLanguageVariantsOfContentTypeWithComponents = function (identifier) {
        return "types/" + identifier.getParamValue() + "/components";
    };
    ContentManagementApiEndpoints.prototype.deleteLanguageVariant = function (itemIdentifier, langaugeIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + langaugeIdentifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.viewOrUpsertLanguageVariant = function (itemIdentifier, langaugeIdentifier) {
        return "items/" + itemIdentifier.getParamValue() + "/variants/" + langaugeIdentifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.viewLanguage = function (identifier) {
        return "languages/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addLanguage = function () {
        return "languages";
    };
    ContentManagementApiEndpoints.prototype.modifyLanguage = function (identifier) {
        return "languages/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.listLanguages = function () {
        return "languages";
    };
    ContentManagementApiEndpoints.prototype.deleteWebhook = function (identifier) {
        return "webhooks/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.getWebhook = function (identifier) {
        return "webhooks/" + identifier.getParamValue();
    };
    ContentManagementApiEndpoints.prototype.addWebhook = function () {
        return "webhooks";
    };
    ContentManagementApiEndpoints.prototype.enableWebhook = function (identifier) {
        return "webhooks/" + identifier.getParamValue() + "/enable";
    };
    ContentManagementApiEndpoints.prototype.disableWebhook = function (identifier) {
        return "webhooks/" + identifier.getParamValue() + "/disable";
    };
    ContentManagementApiEndpoints.prototype.listWebhooks = function () {
        return "webhooks";
    };
    ContentManagementApiEndpoints.prototype.listAssetFolders = function () {
        return 'folders';
    };
    ContentManagementApiEndpoints.prototype.addAssetFolders = function () {
        return 'folders';
    };
    ContentManagementApiEndpoints.prototype.modifyAssetFolders = function () {
        return 'folders';
    };
    return ContentManagementApiEndpoints;
}());
exports.ContentManagementApiEndpoints = ContentManagementApiEndpoints;
exports.contentManagementApiEndpoints = new ContentManagementApiEndpoints();
//# sourceMappingURL=content-management-api-endpoints.js.map